import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexSweetalert',
  setup(__props) {

const BasicAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/BasicAlert.vue"))
const AdvanceAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/AdvanceAlert.vue"))
const UniqueAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/UniqueAlert.vue"))
const DirectionAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/DirectionAlert.vue"))
const InputAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/InputAlert.vue"))
const GithubRTLAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/GithubRTLAlert.vue"))
const SuccessMessage = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/SuccessMessage.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Sweetalert2",
      title: "Sweetalert2"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicAlert)),
        _createVNode(_unref(AdvanceAlert)),
        _createVNode(_unref(UniqueAlert)),
        _createVNode(_unref(DirectionAlert)),
        _createVNode(_unref(InputAlert)),
        _createVNode(_unref(GithubRTLAlert)),
        _createVNode(_unref(SuccessMessage))
      ])
    ])
  ], 64))
}
}

})